import format from 'date-fns/format'

const { NODE_ENV, PUBLIC_URL } = process.env

const i18nOptions = {
  lng: 'pt-BR',

  fallbackLng: false,
  load: 'currentOnly',

  ns: ['common'],
  defaultNS: 'common',

  interpolation: {
    escapeValue: false, // react already safes from xss
    format: (value, pattern) => {
      if (value instanceof Date) {
        return format(value, pattern)
      } else if (pattern === 'cpf') {
        return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4')
      }
      return value
    },
  },
}

if (NODE_ENV === 'production') {
  i18nOptions.backend = {
    loadPath: `${PUBLIC_URL}/locales/{{lng}}/{{ns}}.json`,
  }
}

export { i18nOptions }
